<template>
  <div class="account">
    <el-form
      :inline="true"
      :model="formInline"
      style="padding-top: 10px;margin-left: 18px;margin-bottom:15px;width: 98%"
    >
      <router-link to="/home/chapterManagement/increase">
        <el-button type="primary">+新增用章</el-button>
      </router-link>

      <div style="float: right; display: inline-block">
        <el-date-picker
          v-model="chartTimeValue"
          type="daterange"
          :clearable="false"
          align="center"
          unlink-panels
          value-format="timestamp"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-form-item>
          <el-button type="primary" class="el-icon-search" @click="onSubmit()"></el-button>
        </el-form-item>
      </div>
    </el-form>

    <el-table
      border
      :data="tableData"
      style="width: 98%;margin-left: 18px"
      :header-cell-style="tableHeaderColor"
    >
      <el-table-column type="index" label="序号" width="auto"></el-table-column>
      <el-table-column prop="mangerUserName" label="管理员" width="auto"></el-table-column>
      <el-table-column prop="usedUserName" label="借用人" width="auto"></el-table-column>
      <el-table-column prop="usedTime" label="借用时间"></el-table-column>
      <el-table-column label="是否归还">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status" type="success">已归还</el-tag>
          <el-tag v-else type="warning">未归还</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="returnedTime" label="归还时间"></el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="!scope.row.status" 
            type="primary"
            @click="handleEdit(scope.$index, scope.row)"
          >归还</el-button>
          <el-button
            v-if="scope.row.appendix != ''" 
            @click="download(scope.row.appendix)"
          >附件下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <!-- 分页 -->
      <el-pagination
        small
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync=Current
        :page-size="this.Size"
        layout="total,prev, pager, next, jumper"
        :total="this.total"
      ></el-pagination>
    </div>
  </div>
</template>
<style type="text/css" scoped>
  .el-button--primary {
    color: #fff;
    background-color:  rgb(60, 110, 169);
    border-color: rgb(60, 110, 169);
  }
  .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #fff;
    background-color: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
  }
  .el-button--primary:focus, .el-button--primary:hover {
    background: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
    color: #fff;
  }
#charg {
  width: 100%;
  padding-bottom: 50px;
  background-color: white;
}

.block {
  margin-top: 20px;
  padding-left: 33%;
}

.charg_p {
  border-bottom: 1px solid #e7e7e7;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.68);
  line-height: 70px;
  padding: 0 20px 0 10px;
}

.charg_p div {
  display: inline-block;
}

.right {
  float: right;
}

.inputclass {
  width: 200px !important;
}
</style>

<script>
import { formatDate } from "../../common/date";

export default {
  data() {
    return {
      total: 0,
      formInline: {
        user: "",
        region: "",
        account: ""
      },
      currentPage: 1,
      tableData: [],
      Current: 1,
      Size: 10,
      dataList: {},
      chartTimeValue: [Date.now(), Date.now()]
    };
  }, 
  methods: {
    download(url){
      let turl = url;
      console.log(turl);
      window.open(turl); 
    },
    getinfo() {
      this.$axios({
        method: "POST",
        url: "/api/seal/pageNumber/" + this.Current + "/size/" + this.Size,
        data: this.dataList
      })
        .then(res => {
          let resData = res.data.data;
          console.log(res.data);
          this.tableData = resData.content;
          this.total = resData.totalElements;
        })
        .catch(err => {
          console.log(err);
        });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 蓝色标题样式
      if (rowIndex === 0) {
        return "background-color:#f2f2f2;color: #a4a7af;";      }
    },
    onSubmit: function() {
      this.Current=1;
      if (this.chartTimeValue != null) {
        this.dataList.startDate = formatDate(
          this.chartTimeValue[0],
          "yyyy-MM-dd"
        );
        this.dataList.endDate = formatDate(
          this.chartTimeValue[1],
          "yyyy-MM-dd"
        );
        this.getinfo();
      } else {
        this.$message({
          message: "请选择查询时间",
          type: "warning"
        });
      }
    },
    give(tid) {
      console.log(tid);
      this.$axios({
        method: "PUT",
        url: "/api/seal/" + tid
      })
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            this.$message({
              message: "归还成功",
              type: "success"
            });
            this.getinfo();
          } else {
            this.$message({
              message: "归还失败",
              type: "warning"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleEdit(index, row) {
      this.give(row.id);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.Size = val;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.Current = val;
      this.getinfo();
    }
  },
  created: function() {
    this.dataList = {
      startDate: formatDate(this.chartTimeValue[0], "yyyy-MM-dd"),
      endDate: formatDate(this.chartTimeValue[1], "yyyy-MM-dd")
    };
    this.getinfo();
  }
};
</script>




// WEBPACK FOOTER //
// chapterManagementLi.vue?73fde3d0